import React from 'react';
import { MapPin, Phone, Clock, ExternalLink, Truck } from 'lucide-react';
import { Button } from '../ui/button';
import { productionCenter } from '../../mock';
import { getScheduleSummaryEs } from '../../utils/businessHours';

const ContactSection = ({ locations }) => {
  return (
    <section id="contacto" className="py-20 px-6 bg-chocolate text-white">
      <div className="container mx-auto">
        <h2 className="text-4xl font-bold text-center mb-12">Nuestras Ubicaciones</h2>
        <div className="grid md:grid-cols-2 gap-12">
          {locations.map((location) => (
            <div key={location.id} className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 space-y-6">
              <h3 className="text-2xl font-bold text-caramel">{location.name}</h3>

              {/* Uber Eats Link */}
              <a
                href={location.uberEatsUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Pedir en Uber Eats — ${location.name}`}
                className="flex items-center justify-center space-x-3 bg-gradient-to-r from-black to-gray-900 hover:from-gray-900 hover:to-black text-white rounded-lg p-4 transition-all shadow-lg hover:shadow-xl"
              >
                <svg className="w-32 h-8" viewBox="0 0 110 24" fill="currentColor" aria-hidden="true">
                  <path d="M4.5 0C2.01 0 0 2.01 0 4.5v15C0 21.99 2.01 24 4.5 24h15c2.49 0 4.5-2.01 4.5-4.5v-15C24 2.01 21.99 0 19.5 0h-15zm7.5 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm0 2c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/>
                  <text x="28" y="17" className="text-[16px] font-bold" fill="white">Uber Eats</text>
                </svg>
                <ExternalLink className="w-5 h-5" />
              </a>

              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <MapPin className="w-6 h-6 text-caramel flex-shrink-0 mt-1" />
                  <div>
                    <div className="font-semibold">Dirección</div>
                    <div className="text-white/80">{location.address}</div>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <Clock className="w-6 h-6 text-caramel flex-shrink-0 mt-1" />
                  <div>
                    <div className="font-semibold">Horario</div>
                    <div className="text-white/80 space-y-1">
                      {getScheduleSummaryEs(
                        String(location.name).toLowerCase().includes('sucursal') ? 'sucursal' : 'matriz'
                      )
                        .split(' · ')
                        .map((line, i) => (
                          <div key={i}>{line}</div>
                        ))}
                    </div>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <Phone className="w-6 h-6 text-caramel flex-shrink-0 mt-1" />
                  <div>
                    <div className="font-semibold">Teléfono</div>
                    <div className="text-white/80">+{location.phone}</div>
                  </div>
                </div>
              </div>
              <Button 
                onClick={() => window.open(`https://wa.me/593984814807`, '_blank')}
                className="w-full bg-green-600 hover:bg-green-700 text-white shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-2"
              >
                <Phone className="w-5 h-5" />
                Contactar por WhatsApp
              </Button>
              <div className="rounded-xl overflow-hidden relative group">
                <iframe
                  src={location.mapUrl}
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`${location.name} Location`}
                ></iframe>
                <a 
                  href={location.googleMapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="absolute inset-0 bg-black/0 hover:bg-black/20 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100"
                >
                  <span className="bg-white text-chocolate px-4 py-2 rounded-full font-semibold shadow-lg flex items-center space-x-2">
                    <MapPin className="w-4 h-4" />
                    <span>Abrir en Google Maps</span>
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Centro de producción: va aparte de las tarjetas de local porque no se
            atiende ahí — es solo el origen de los domicilios. */}
        <div className="mt-10 max-w-3xl mx-auto flex items-start gap-3 bg-white/5 border border-white/10 rounded-xl p-5">
          <Truck className="w-5 h-5 mt-0.5 shrink-0 text-caramel" />
          <p className="text-sm text-white/80 leading-relaxed">
            <span className="font-semibold text-caramel">{productionCenter.name}:</span>{' '}
            {productionCenter.address}
            <span className="block mt-1 text-white/60">{productionCenter.note}</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
